import { render, staticRenderFns } from "./promptMessage.vue?vue&type=template&id=65887a21&scoped=true"
import script from "./promptMessage.vue?vue&type=script&lang=js"
export * from "./promptMessage.vue?vue&type=script&lang=js"
import style0 from "./promptMessage.vue?vue&type=style&index=0&id=65887a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65887a21",
  null
  
)

export default component.exports